/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {
  Card,
  Form,
  Button,
  Spin,
  Radio,
  Space,
  Input,
  Row,
  Col,
  Divider,
  InputNumber,
  message,
} from 'antd';

import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUserData } from '../../helpers/functions';
import { IoMdArrowRoundBack } from 'react-icons/io';
const { TextArea } = Input;

const Invoice = ({ handleNext, handleBack }) => {
  const dispatch = useDispatch();
  const { qid } = useParams();
  const [form] = Form.useForm();
  const [selectedId, setSelectedId] = useState('');
  const { isInvoiceLoading, invoiceList } = useSelector(state => state.common);
  const { isStepUpdating, stepUpdateMsg } = useSelector(state => state.steps);
  const [selectedType, setSelectedType] = useState('');
  const { isQuestionLoading, questionDetail } = useSelector(state => state.common);
  useEffect(() => {
    dispatch({ type: 'GET_INVOICE_REQUEST', formData: { status: 'active' } });
  }, []);

  useEffect(() => {
    if (qid) {
      dispatch({ type: 'GET_QUESTION_DETAIL', id: qid });
    }
  }, []);
  const onChange = e => {
    setShowInvoiceCustomRange(false);
  };

  useEffect(() => {
    if (!isQuestionLoading && Object.keys(questionDetail).length > 0) {
      setSelectedType(questionDetail.customer_type !== null ? questionDetail.customer_type.id : '');
      form.setFieldsValue({
        customer_type_id:
          questionDetail.customer_type !== null ? questionDetail.customer_type.id : '',
      });
    }
  }, [isQuestionLoading, questionDetail]);

  const onFinish = async values => {
    if (qid) {
      let invoice_id;
      try {
        const customRange = await customInvoiceRangeform.validateFields();
        if (customRange.from && customRange.to) {
          invoice_id = {
            from: String(customRange.from),
            to: String(customRange.to),
          };
        } else {
          invoice_id = values.invoices_id;
        }
      } catch (error) {
        console.log(error, 'in catch');
        return;
      }
      if(!invoice_id){
        message.error('Please select invoice range');
        return;
      }
      dispatch({
        type: 'QUESTION_STEP_UPDATE_REQUEST',
        formData: {
          ...values,
          user_id: getUserData().id,
          invoices_id: invoice_id,
          id: qid,
        },
        requestType: 'post',
        step: 'update-invoice',
      });
    }
  };

  useEffect(() => {
    if (!isStepUpdating && stepUpdateMsg === 'success') {
      handleNext(qid, 'main-category', 'invoice');
      dispatch({ type: 'CLEAR_STEPS' });
    }
  }, [isStepUpdating, stepUpdateMsg]);
  const [customInvoiceRangeform] = Form.useForm();
  const [customLanguageForm] = Form.useForm();
  const [showInvoiceCustomRange, setShowInvoiceCustomRange] = useState(false);
  const [showCustomLanguageInput, setShowCustomLanguageInput] = useState(false);
  useEffect(() => {
    if (questionDetail.to && questionDetail.from) {
      customInvoiceRangeform.setFieldsValue({
        from: questionDetail.from,
        to: questionDetail.to,
      });
      setShowInvoiceCustomRange(true);
    } else {
      customInvoiceRangeform.setFieldsValue({
        from: null,
        to: null,
      });
      form.setFieldsValue({
        invoices_id: questionDetail?.invoices?.id,
      });
      setShowInvoiceCustomRange(false);
    }
  }, [questionDetail]);
  useEffect(() => {
    if (showInvoiceCustomRange) {
      form.setFieldsValue({
        invoices_id: null,
      });
    } else {
      form.setFieldsValue({
        invoices_id: questionDetail?.invoices?.id,
      });
    }
  }, [showInvoiceCustomRange]);
  return (
    <div>
      <div className="site-card-border-less-wrapper card-wrapper">
        <Card bordered={false}>
          {isInvoiceLoading && <Spin />}
          {!isInvoiceLoading && (
            <>
              <p className="m-title tl mb-7 d-flex-center">
                <span
                  className="back-icon"
                  onClick={() =>
                    handleBack(qid, selectedType === 5 ? 'invoice-ownership' : 'invoice-business')
                  }
                >
                  <IoMdArrowRoundBack />
                </span>
                <span>How many invoices do you handle per month?</span>
              </p>
              <Form form={customInvoiceRangeform} layout="horizontal">
                <Row align="middle" gutter={[16, 16]}>
                  {/* Button */}
                  <Col>
                    <Form.Item>
                      <span
                        className="capsule"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setShowInvoiceCustomRange(!showInvoiceCustomRange)}
                      >
                        {showInvoiceCustomRange ? 'Hide Custom Range' : 'Custom Range'}
                      </span>
                    </Form.Item>
                  </Col>
                  {showInvoiceCustomRange && (
                    <>
                      <Col>
                        <Form.Item
                          label="From"
                          name="from"
                          rules={[{ required: true, message: 'Please enter a starting number' }]}
                        >
                          <InputNumber min={0} />
                        </Form.Item>
                      </Col>

                      <Col>
                        <Form.Item
                          label="To"
                          name="to"
                          dependencies={['from']}
                          rules={[
                            { required: true, message: 'Please enter an ending number' },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const fromValue = getFieldValue('from');
                                if (value === undefined || fromValue === undefined) {
                                  return Promise.resolve();
                                }
                                if (value > fromValue) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('To must be greater than From'));
                              },
                            }),
                          ]}
                        >
                          <InputNumber min={0} />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </Form>
              <Form
                layout="vertical"
                name="basic"
                // initialValues={{ remember: true }}
                form={form}
                onFinish={onFinish}
              >
                <Form.Item
                  name="invoices_id"
                  // initialValue={1}
                  // rules={[{ message: 'Please select at least one option' }]}
                >
                  <Radio.Group
                    className={'mt3'}
                    style={{ width: '100%' }}
                    onChange={onChange}
                    // defaultValue={1}
                  >
                    <Space direction="vertical" size={'middle'} style={{ width: '100%' }}>
                      {invoiceList.map(item => {
                        return (
                          <>
                            <Radio
                              style={{ fontSize: '18px' }}
                              key={item.id}
                              value={item.id}
                              dataAttr={item.slug}
                            >
                              {' '}
                              {item.name}
                            </Radio>
                          </>
                        );
                      })}
                    </Space>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name="invoices_id"
                  // initialValue={1}
                  // rules={[{ message: 'Please select at least one option' }]}
                ></Form.Item>
                <Divider className="mt40 mb40" />
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="middle"
                    className="mt5"
                    loading={isStepUpdating}
                    disabled={isStepUpdating}
                  >
                    Next
                  </Button>
                </Form.Item>
              </Form>
            </>
          )}
        </Card>
      </div>
    </div>
  );
};
export default Invoice;
